import { gql } from '@/__generated__/gql';

export const EDIT_STRATEGY_PAGE_INVESTMENT_QUERY = gql(`
  query EditStrategyPageInvestment($id: String!) {
    Investment(id: $id) {
      id
      symbol
      name
      type
      managerId
      pacingType
      pacingStartingQuarter
      pacingStartingYear
      ubtiBlocker
      custodied
      assetClass {
        id
        name
      }
      subAssetClass {
        id
        name
      }
      investmentVehicles {
        id
        name
        investmentId
        createdAt
        deletedAt
      }
      sectors
      averageCalledPercent
      countOfInvestors
      committedCapital
      economicExposure
      targetReturn
      targetYield
      vintageYear
      nextClose
      finalClose
      investorDocsDue
      minimum
      sri
      subAssetClasses
      tags
      description
      securityStatus
      investmentOwner {
        firstName
        lastName
        email
      }
      operationsOwner {
        firstName
        lastName
        email
      }
      complianceOwner {
        firstName
        lastName
        email
      }
      offeringMaterialsDescription
      offeringMaterialsAttachments {
        id
        asset {
          url
          assetKey
        }
        visibility
      }
      advisoryFirms {
        id
        name
      }
      showToAllAdvisoryFirms
      workflowInstance {
        id
        currentState {
          label
          name
        }
      }
    }
  }
`);

export const EDIT_STRATEGY_PAGE_INVESTMENTS_QUERY = gql(`
  query EditStrategyPageInvestments($page: Int, $rowsPerPage: Int, $sort: String, $order: String, $managerIdFilter: String) {
    Investments(page: $page, rowsPerPage: $rowsPerPage, sort: $sort, order: $order, managerIdFilter: $managerIdFilter) {
      data {
        id
        name
      }
    }
  }
`);

export const UPDATE_INVESTMENT_MANAGER_MUTATION = gql(`
  mutation UpdateInvestmentManager($data: UpdateInvestmentManagerInput!) {
    InvestmentManagerUpdate(data: $data) {
      id
    }
  }
`);
